<template>
	<section
		class="content-wrapper training"
		style="min-height: 100vh; height: 100%"
	>
		<router-link to="/" exact class="btn btn-back">
			<img
				src="images/chevron-left-green.svg"
				style="margin-right: 6px"
			/>powrót
		</router-link>
		<div class="clearfix">
			<h1 class="float-left">Szkolenia</h1>
			<div class="float-right text-right trining-counter">
				<p class="mb-3">Zaplanowane szkolenia</p>
				<span>{{ trainingList.length }}</span>
			</div>
		</div>
		<br />
		<div class="text-right mb-3">
			<button
				@click="toggleTraining(1)"
				type="button"
				:class="[
					'btn',
					activeTabId == 1 ? 'btn-primary' : 'btn-secondary',
				]"
			>
				Webinary
			</button>
			<button
				@click="toggleTraining(2)"
				type="button"
				:class="[
					'btn',
					activeTabId == 2 ? 'btn-primary' : 'btn-secondary',
				]"
			>
				Szkolenia stacjonarne
			</button>
		</div>
		<div class="training-list">
			<template v-if="windowWidth >= mobileBreakpoint">
				<template v-for="training in trainingList">
					<div
						v-if="training.groupId == activeTabId"
						:key="training.id"
						class="training-item"
					>
						<header>
							<span>
								<span>{{
									$filters.day(training.trainingDate)
								}}</span>
								{{
									$filters.monthAndYear(training.trainingDate)
								}}
							</span>

							<span
								>&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;godzina:
								{{ $filters.time(training.trainingDate) }}</span
							>

							<button
								type="button"
								class="btn btn-primary float-right"
								:disabled="training.canRegister !== 1"
								@click="register(training)"
							>
								Rejestracja
							</button>
						</header>
						<div class="clearfix">
							<div class="training-content">
								<h3>{{ removeHtml(training.name) }}</h3>
								<p>{{ removeHtml(training.description) }}</p>
							</div>
							<div class="training-info text-right">
								<p class="text-primary">
									{{ canRegisterText(training.canRegister) }}
								</p>
								<p v-if="training.trainerName">
									Prowadzący:
									<br />
									<span>{{ training.trainerName }}</span>
								</p>
								<p v-if="training.fullAddress">
									Dokładny adres:
									<br />
									<span>{{ training.fullAddress }}</span>
								</p>
								<p v-if="training.place">
									Miejsce:
									<br />
									<span>{{ training.place }}</span>
								</p>
							</div>
						</div>
					</div>
				</template>
			</template>
			<template v-else>
				<template v-for="training in trainingList">
					<div
						v-if="training.groupId == activeTabId"
						:key="training.id"
						class="training-item"
					>
						<header>
							<span>
								<span>
									{{ $filters.day(training.trainingDate) }}
								</span>
								{{
									$filters.monthAndYear(training.trainingDate)
								}}
							</span>
							<span class="d-block pt-3"
								>godzina:
								{{ $filters.time(training.trainingDate) }}
							</span>
						</header>
						<div class="clearfix">
							<div class="training-content">
								<h3
									style="
										font-family: OpenSans-Bold, sans-serif;
									"
								>
									{{ removeHtml(training.name) }}
								</h3>
								<div class="training-info-mobile my-3">
									<p
										v-if="training.trainerName"
										style="
											font-family: OpenSans-Bold,
												sans-serif;
										"
									>
										Prowadzący:
										<br />
										<span
											style="
												font-family: OpenSans,
													sans-serif;
											"
											>{{ training.trainerName }}</span
										>
									</p>
									<p
										v-if="training.fullAddress"
										style="
											font-family: OpenSans-Bold,
												sans-serif;
										"
									>
										Dokładny adres:
										<br />
										<span
											style="
												font-family: OpenSans,
													sans-serif;
											"
											>{{ training.fullAddress }}</span
										>
									</p>
									<p
										v-if="training.place"
										style="
											font-family: OpenSans-Bold,
												sans-serif;
										"
									>
										Miejsce:
										<br />
										<span
											style="
												font-family: OpenSans,
													sans-serif;
											"
											>{{ training.place }}</span
										>
									</p>
								</div>
								<p>{{ removeHtml(training.description) }}</p>
							</div>

							<button
								type="button"
								class="btn btn-primary mx-auto mt-2"
								:disabled="training.canRegister !== 0"
								@click="register(training)"
							>
								Rejestracja
							</button>
						</div>
					</div>
				</template>
			</template>
		</div>
		<training-registration-notification
			v-if="$store.getters.getDisplayRegistrationModal"
			:info="dataForNotification"
		></training-registration-notification>
		<br />
		<router-link
			to="/"
			v-if="windowWidth < mobileBreakpoint"
			exact
			class="btn btn-secondary"
			>Powrót</router-link
		>
	</section>
</template>

<script>
import TrainingRegistrationNotification from '@/views/training/partial/_TrainingRegistrationNotification';
import { mapGetters } from 'vuex';
import { stringFunctions } from '@/mixins/string-functions.js';

export default {
	data() {
		return {
			dataForNotification: {},
			activeTabId: null,
		};
	},
	components: {
		TrainingRegistrationNotification,
	},
	mixins: [stringFunctions],
	methods: {
		register(training) {
			this.$store.dispatch('postTrainingRegistration', training.id);
			this.dataForNotification = training;
		},
		canRegisterText(canRegister) {
			switch (canRegister) {
				case 0:
					return '';
				case 1:
					return '';
				case 2:
					return 'Zarejestrowany';
				default:
					return '';
			}
		},
		toggleTraining(id) {
			this.activeTabId = id;
			this.$cookies.set('LastActiveTrainingTab', this.activeTabId);
		},
	},
	computed: {
		trainingList() {
			return this.$store.getters.getTrainingList
				? this.$store.getters.getTrainingList
				: false;
		},
		windowWidth() {
			return this.$store.getters.getWindowWidth;
		},
		...mapGetters({ mobileBreakpoint: 'getMobileBreakpoing' }),
	},
	mounted() {
		let cookie = 'LastActiveTrainingTab';
		let now = new Date();
		let endDate = new Date(now.getTime() + 600000);

		if (!this.$cookies.isKey(cookie)) {
			//    this.activeTabId = 2
			this.activeTabId = 1;
		} else {
			if (this.$cookies.get(cookie) == 1) {
				this.activeTabId = 1;
			} else if (this.$cookies.get(cookie) == 2) {
				this.activeTabId = 2;
			}
		}
		this.$cookies.set(cookie, this.activeTabId, endDate);
	},
};
</script>

<style>
.trining-counter {
	margin-top: 40px;
}

.trining-counter span {
	font-size: 45px;
	font-family: 'OpenSans-Bold', sans-serif;
	margin-top: 10px;
}
</style>
